export default "__VITE_ASSET__CQsR430V__"